import BaseAPI from "./BaseAPI";
import { auditRoute } from "../routes";

export default class AuditAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, auditRoute, "audit");
    }

    async Create(data, idempotencyKey = null) {
        const options = idempotencyKey
            ? { headers: { "Idempotency-Key": idempotencyKey } }
            : {};
        const result = await this._request("post", this._url(), data, options);
        this._emit("create", result.id);
        return result;
    }
}
